import { OWA_AUTO_LINKS_CLASSNAME } from 'owa-attachment-link-common';
import * as ReactDOM from 'react-dom';

export function removeReactContent(entityElement: HTMLElement) {
    const beautifulLink = entityElement.querySelectorAll('.' + OWA_AUTO_LINKS_CLASSNAME)?.[0];
    if (beautifulLink) {
        ReactDOM.unmountComponentAtNode(beautifulLink.parentElement);
    }
}
